var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83331 0.666656C2.17027 0.666656 1.53439 0.930049 1.06555 1.39889C0.596705 1.86773 0.333313 2.50362 0.333313 3.16666V15.7817C0.333238 16.0006 0.390684 16.2158 0.4999 16.4056C0.609117 16.5953 0.766272 16.7531 0.955632 16.8631C1.14499 16.973 1.35991 17.0313 1.57888 17.0321C1.79785 17.0329 2.01318 16.9761 2.20331 16.8675L6.58665 14.3625C6.71253 14.2906 6.855 14.2528 6.99998 14.2528C7.14496 14.2528 7.28743 14.2906 7.41331 14.3625L11.7966 16.8675C11.9868 16.9761 12.2021 17.0329 12.4211 17.0321C12.64 17.0313 12.855 16.973 13.0443 16.8631C13.2337 16.7531 13.3908 16.5953 13.5001 16.4056C13.6093 16.2158 13.6667 16.0006 13.6666 15.7817V3.16666C13.6666 2.50362 13.4033 1.86773 12.9344 1.39889C12.4656 0.930049 11.8297 0.666656 11.1666 0.666656H2.83331Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.c8d73d0bfbfc17e6d96eb61756b0e8f2.svg";
export { ForwardRef as ReactComponent };